import React from 'react'
import BannerBrandImageSection from '../../../bannerBrandImageSection'
import { IOpportunityLostStageProps } from '../stages/interfaces/IOpportunityLostStageProps'
import globals from 'application/constants/globals'

const OpportunityLostStage = (props: IOpportunityLostStageProps) => {
  const { firstName } = props
  var sectionTitle = ""
  var phoneNo = globals.isBrandMX ? "1300 123 123" : "1300 73 14 29"
  var sectionContent = `Not to worry ${firstName}, one of our novated leasing consultants will be happy to help. Give them a call on ${phoneNo}.`
  var bannerImageText = "Here to help"

  return (
    <BannerBrandImageSection
      id="opportunityloststage.bannermainsection"
      imageText={bannerImageText}
      sectionContent={sectionContent}
      sectionTitle={sectionTitle}
      showConsultantButton={false}
    />
  )
}

export default OpportunityLostStage
